import { LicenseInfo } from '@mui/x-license'

LicenseInfo.setLicenseKey(
	'8f64e064762a8c536cbc112759505af7Tz0xMTQwNTcsRT0xNzgwNzAzOTk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9UTEtMjAyNixRPTEsS1Y9Mg==',
)
